exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrap[data-v-03649ae4]{margin:0 auto;width:96%}h1[data-v-03649ae4]{margin-top:20px;color:#127281;font-size:3em;text-transform:uppercase;font-weight:700}.banner[data-v-03649ae4]{text-align:center;margin-top:30px}.banner img[data-v-03649ae4]{margin-top:0}.page[data-v-03649ae4]{text-align:center;font-family:Century Gothic}.page h2[data-v-03649ae4]{font-size:3em;color:#127281;font-weight:700}.footer[data-v-03649ae4]{font-family:Century Gothic;text-align:right;margin-top:2em}.footer p[data-v-03649ae4]{font-size:1em;color:#603813}.footer a[data-v-03649ae4]{color:#f9614d}.footer a[data-v-03649ae4]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03649ae4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/common/ErrorNotFound.vue
// module id = 789
// module chunks = 1